import React from "react";
import {RouteObject} from 'react-router-dom';
import DashboardLayout from "../../layout/DashboardLayout/DashboardLayout";

const  DashboardRoutes : RouteObject[] = [
    {
        path:'dashboard',
        element:<DashboardLayout/>
    }
]

export default DashboardRoutes;